import { render, staticRenderFns } from "./DataTablePageIndicator.vue?vue&type=template&id=449755de&scoped=true&"
import script from "./DataTablePageIndicator.vue?vue&type=script&lang=ts&"
export * from "./DataTablePageIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./DataTablePageIndicator.vue?vue&type=style&index=0&id=449755de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449755de",
  null
  
)

export default component.exports